import { Injectable } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormularioDocumentoService } from './formulario-documento.service';
import { validacionIdentificadorCampoDuplicado, validacionIdentificadorPalabras, validacionOrdenOpcionDuplicada } from './customValidatorsDocs';
import { DatosTiposContenidoService } from './datos-tipos-contenido.service';

@Injectable({
  providedIn: 'root'
})
export class ExtraInfoCasillasCamposService {

  formularioCasillas: FormGroup;
  formularioCampos: FormGroup;
  formularioPalabras: FormGroup;

  constructor(private fb: FormBuilder,
              private formularioDocumentoService: FormularioDocumentoService,
              private datosTiposContenidoService: DatosTiposContenidoService) { }

  inicializarFormularioCasillas(data: any){
    let ordenOpcionC = data?.orden;
    let valorOpcionSeleccionadaC = data?.valorOpcionSeleccionada ?? '';
    let obligatorioC = data?.obligatorio ?? false;
    let formulariosMismoGrupo: any[] = [];

    const firmantesNif = this.formularioDocumentoService.formularioDocumento.get('firmantesNif') as FormArray;
    const firmanteCodigo = data?.firmante?.codigo;
    const nombreFormulario = data?.nombre;
    firmantesNif.controls.forEach((firmanteFG: AbstractControl) => {
      const formularios = firmanteFG.get('formularios') as FormArray;
      formularios.controls.forEach((formularioFG: AbstractControl) => {
        const formularioValue = formularioFG.value;
        const mismoFirmante = !firmanteCodigo || formularioValue?.firmante?.codigo === firmanteCodigo;
        const mismoNombre = !nombreFormulario || formularioValue?.nombre === nombreFormulario;
        if (mismoFirmante && mismoNombre) {
          formulariosMismoGrupo.push(formularioValue);
        }

        if (formularioFG.get('id')?.value == data.id) {
          ordenOpcionC = formularioFG.get('orden')?.value;
          valorOpcionSeleccionadaC = formularioFG.get('valorOpcionSeleccionada')?.value;
          obligatorioC = formularioFG.get('obligatorio')?.value;
        }
      });
    });

    this.formularioCasillas = this.fb.group({
      ordenOpcion: [ordenOpcionC, validacionOrdenOpcionDuplicada(formulariosMismoGrupo, data.id)],
      valorOpcionSeleccionada: [valorOpcionSeleccionadaC ?? ''],
      obligatorio: [obligatorioC ?? false],
      id: [data.id ?? 0]
    });
  }

  inicializarFormularioCampos(data: any){
    let identificadorC;
    let nombreC;
    let valorPD;
    let obligatorioC = false;

    const firmantesNif = this.formularioDocumentoService.formularioDocumento.get('firmantesNif') as FormArray;
    let camposEditables: FormArray;
    firmantesNif.controls.forEach((firmanteFG: AbstractControl) => {
      camposEditables = firmanteFG.get('camposEditables') as FormArray;

      camposEditables.controls.forEach((campoFG: AbstractControl) => {
        if (campoFG.get('id')?.value === data.id) {
          identificadorC = campoFG.get('identificador')?.value;
          nombreC = campoFG.get('nombreCampo')?.value;
          valorPD = campoFG.get('valorPorDefecto')?.value;
          obligatorioC = campoFG.get('obligatorio')?.value;
        }
      });
    });

    this.formularioCampos = this.fb.group({
      // identificadorCampo: [identificadorC],
      identificadorCampo: [identificadorC, validacionIdentificadorCampoDuplicado(camposEditables.value, data.id)],
      nombreCampo: [nombreC ?? ''],
      valorPorDefecto: [valorPD ?? ''], //quitamos validacionTiposContenido ya que ahora hay un esplegalbe y siempre será un magicword
      obligatorio: [obligatorioC ?? false],
      id: [data.id ?? 0]
    });
  }

  inicializarFormularioPalabras(data: any){
    const tiposContenido = this.formularioDocumentoService.formularioDocumento.controls['tiposContenido'] as FormArray;
    const identificadorPalabra = tiposContenido.controls.find(x => x.get('id')?.value == data.id)?.get('identificador')?.value;
    const nombrePalabra = tiposContenido.controls.find(x => x.get('id')?.value == data.id)?.get('nombre')?.value;
    this.formularioPalabras = this.fb.group({
      identificadorPalabra: [identificadorPalabra],
      nombrePalabra: [nombrePalabra ?? ''],
      id: [data.id ?? 0]
    });
    // this.formularioPalabras = this.fb.group({
    //   identificadorPalabra: [identificadorPalabra, validacionIdentificadorPalabras(tiposContenido.value, data.id)], //y no duplicado
    //   nombrePalabra: [nombrePalabra ?? ''],
    //   id: [data.id ?? 0]
    // });
  }


}
